export default "__VITE_ASSET__BRIs8uB6__"